import { ClientAuthError, ServerError } from '@azure/msal-browser';
import { Button, Stack, Typography } from '@mui/material';

import ThemeCustomization from '../themes';

const GlobalErrorFallback = (data) => {
  const { error } = data;
  let errorContents = (
    <Typography align={'center'}>
      An unexpected error has occurred, please try refreshing the page. Please contact support if
      this happens again.
    </Typography>
  );

  if (error instanceof ClientAuthError || error instanceof ServerError) {
    errorContents = (
      <>
        <Typography align={'center'}>
          An unexpected error has occurred during authentication, you may retry by clicking the
          button below. Please contact support if this happens again.
        </Typography>
        <Typography align={'center'}>
          <Button
            variant='outlined'
            color='secondary'
            sx={{ margin: '5px' }}
            onClick={() => {
              window.location.href = '/';
            }}
          >
            Retry
          </Button>
        </Typography>
      </>
    );
  }
  if (error instanceof ServerError && error.errorMessage) {
    if (error.errorMessage.startsWith('AADB2C90091')) {
      errorContents = (
        <>
          <Typography align={'center'}>
            You have canceled the authentication attempt. You may retry by clicking the button
            below.
          </Typography>
          <Typography align={'center'}>
            <Button
              variant='outlined'
              color='secondary'
              sx={{ margin: '5px' }}
              onClick={() => {
                window.location.href = '/';
              }}
            >
              Sign In
            </Button>
          </Typography>
        </>
      );
    } else if (
      error.errorMessage.startsWith('AADB2C90075') &&
      error.errorMessage.indexOf('checkAndAppendTenantPostFix') > 0 &&
      error.errorMessage.indexOf("'NotFound'") > 0
    ) {
      errorContents = (
        <>
          <Typography align={'center'}>
            The invite code you have used is no longer valid, it may have been revoked. Please
            contact the person who originally sent it.
          </Typography>
        </>
      );
    }
  }

  return (
    <ThemeCustomization>
      <Stack
        direction='column'
        justifyContent='center'
        alignItems='center'
        sx={{ width: 1, height: '100vh' }}
      >
        {errorContents}
      </Stack>
    </ThemeCustomization>
  );
};

export default GlobalErrorFallback;
